var map = {
	"./": 48897,
	"./About": 20024,
	"./About.js": 20024,
	"./AutoMenu": 81314,
	"./AutoMenu.js": 81314,
	"./BakeryHero.css": 53850,
	"./BakeryVideo": 92488,
	"./BakeryVideo.js": 92488,
	"./Banquet": 2567,
	"./Banquet.js": 2567,
	"./Bogo": 74218,
	"./Bogo.js": 74218,
	"./CartBar": 24958,
	"./CartBar.js": 24958,
	"./Catering": 64514,
	"./Catering.js": 64514,
	"./CateringInquiry": 70725,
	"./CateringInquiry.js": 70725,
	"./Contact": 37793,
	"./Contact.js": 37793,
	"./CustomerReviews": 44455,
	"./CustomerReviews.js": 44455,
	"./CustomerReviews.scss": 97311,
	"./DineInNotice": 47941,
	"./DineInNotice.js": 47941,
	"./DineInNotice.scss": 77956,
	"./Events": 42330,
	"./Events.js": 42330,
	"./Events.scss": 65915,
	"./FeaturedProducts": 56073,
	"./FeaturedProducts.js": 56073,
	"./Form.scss": 84529,
	"./FormJob": 36384,
	"./FormJob.js": 36384,
	"./HamburgerMenu": 66926,
	"./HamburgerMenu.js": 66926,
	"./HamburgerMenu.scss": 26969,
	"./Headers": 32519,
	"./Headers.js": 32519,
	"./LocationsView": 81413,
	"./LocationsView.js": 81413,
	"./MainNavigation": 90148,
	"./MainNavigation.js": 90148,
	"./Menu": 11958,
	"./Menu.js": 11958,
	"./MenuCategoriesPreview": 78261,
	"./MenuCategoriesPreview.js": 78261,
	"./MenuCategoriesPreview.scss": 14382,
	"./MenuCategoryListView": 92787,
	"./MenuCategoryListView.js": 92787,
	"./NewsEvents": 98080,
	"./NewsEvents.js": 98080,
	"./NewsEvents.scss": 56753,
	"./Order": 68726,
	"./Order.js": 68726,
	"./OrderAltadena": 64940,
	"./OrderAltadena.js": 64940,
	"./OurStoryPage": 51951,
	"./OurStoryPage.js": 51951,
	"./ProductSlideshow": 86006,
	"./ProductSlideshow.js": 86006,
	"./ProductSlideshow.scss": 63511,
	"./PromoOverlay": 75473,
	"./PromoOverlay.js": 75473,
	"./PromoOverlay.scss": 9047,
	"./ReataurantMap": 24798,
	"./ReataurantMap.js": 24798,
	"./SocialLinks": 47122,
	"./SocialLinks.js": 47122,
	"./Splash": 23687,
	"./Splash.js": 23687,
	"./Splash.scss": 67739,
	"./Taconight": 40452,
	"./Taconight.js": 40452,
	"./ThemeToggle": 7434,
	"./ThemeToggle/": 7434,
	"./ThemeToggle/Toggle": 84507,
	"./ThemeToggle/Toggle.css": 35472,
	"./ThemeToggle/Toggle.js": 84507,
	"./ThemeToggle/index": 7434,
	"./ThemeToggle/index.js": 7434,
	"./ThemeToggle/moon.png": 10699,
	"./ThemeToggle/sun.png": 7186,
	"./ThemeToggle/theme_night.scss": 54703,
	"./about.md": 55296,
	"./about.scss": 81771,
	"./ai-styleguide.md": 11446,
	"./altStyleA.scss": 88862,
	"./assets/Christmas Eve & Day Menus.jpeg": 94786,
	"./assets/Christmas Eve & Day Specials.jpeg": 61077,
	"./assets/berni-b-1.jpg": 10330,
	"./assets/david-peterson-1.jpg": 71792,
	"./assets/lou-vargas-1.jpg": 72750,
	"./assets/lou-vargas-2.jpg": 8286,
	"./burgermenu.scss": 18122,
	"./catering.scss": 85046,
	"./changes.md": 40658,
	"./darkmode.scss": 54587,
	"./index": 48897,
	"./index.js": 48897,
	"./index.scss": 45396,
	"./locationsData": 35916,
	"./locationsData.js": 35916,
	"./reviews": 48067,
	"./reviews.json": 48067,
	"./reviews.md": 93886,
	"./svg/LogoBar": 82959,
	"./svg/LogoBar.js": 82959,
	"./svg/LogoHero": 95195,
	"./svg/LogoHero.js": 95195,
	"./taron-logo.png": 25765
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79131;